import { useMemo } from 'react';

import { VisitView } from '@dreryk/egabinet-dashboard-frontend-api';

import { LineChart } from '@dreryk/react-charts';
import { useTranslate } from '@dreryk/react-common';

import { dashboardTranslationKeys } from '../../../translations';
import { TooltipCard } from '../shared/TooltipCard';

import { StyledConfirmedAppointmentsChart } from './ConfirmedAppointmentsChart.styled';
import { mapVisitsToChartData } from './ConfirmedAppointmentsChart.utils';

type ConfirmedAppointmentsChartProps = {
   readonly visitsView: VisitView[];
};

export const ConfirmedAppointmentsChart = (props: ConfirmedAppointmentsChartProps): JSX.Element => {
   const translate = useTranslate();
   const data = useMemo(() => {
      return mapVisitsToChartData(props.visitsView, translate);
   }, [props.visitsView, translate]);

   return (
      <StyledConfirmedAppointmentsChart>
         <LineChart
            stackSeriesIndex={1}
            data={data}
            tooltip={(slice) => <TooltipCard data={slice} label={dashboardTranslationKeys.cards.confirmedCount} />}
         />
      </StyledConfirmedAppointmentsChart>
   );
};
